import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import InputComponent from './Input'
import { createShow, deleteShow, editShow } from '../helpers/shows'
import { getCoordinates } from '../helpers/coordinates'
import firebase from 'firebase'
import FileUploader from 'react-firebase-file-uploader'
import UploadFile from './UploadFile/UploadFile'

//const edition = process.env.REACT_APP_EDITION

const artistFields = [
    {
        text: 'artist',
        key: 'artist',
        placeholder: 'Artist Name',
        entryType: 'text',
    },
    {
        text: 'email',
        placeholder: 'contact email',
        key: 'email',
        entryType: 'text',
    },
]
const scheduleFields = [
    {
        text: 'start time',
        key: 'startTime',
        placeholder: '',
        entryType: 'showTime',
    },
    {
        text: 'Duration',
        key: 'duration',
        placeholder: '',
        entryType: 'duration',
    },
    {
        text: 'end time',
        key: 'endTime',
        placeholder: '',
        entryType: 'showTime',
        disabled: true,
    },
]
const showFields = [
    {
        text: 'title',
        key: 'title',
        placeholder: '(optional) Show Title',
        entryType: 'text',
    },
    {
        text: 'stream link',
        placeholder: 'twitch, vimeo, network.currents...',
        key: 'link',
        entryType: 'text',
    },
]
const descField = [
    {
        text: 'currents ID',
        placeholder: 'Currents ID of channel',
        key: 'currentsID',
        entryType: 'text',
    },
    {
        text: 'artist bio/description',
        placeholder: 'description of the function',
        key: 'description',
        entryType: 'area',
    },
]
const fields = [
    {
        text: 'title',
        key: 'title',
        placeholder: '(optional) Show Title',
        entryType: 'text',
    },
    {
        text: 'start time',
        key: 'startTime',
        placeholder: '',
        entryType: 'showTime',
    },
    {
        text: 'Duration',
        key: 'duration',
        placeholder: '',
        entryType: 'duration',
    },
    {
        text: 'end time',
        key: 'endTime',
        placeholder: '',
        entryType: 'showTime',
        disabled: true,
    },
    {
        text: 'stream link',
        placeholder: 'twitch, vimeo, network.currents...',
        key: 'link',
        entryType: 'text',
    },
]

const optionalFields = [
]

const customStyles = {
    direction: 'flex',
    flexDirection: 'row',
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '960px',
        height: 640,
        backgroundColor: 'black',
        color: 'white',
        borderRadius: 0,
    },
    overlay: {
        backgroundColor: 'rgba(0,0,0,.8)',
    },
}

Modal.setAppElement('#root')

function ShowForm(props) {
    var subtitle
    const { getEdition, handleGetShows, roomData, shows, show, formType, room, edition } = props
    const newShow = {
        type: 'single',
        room,
        link: roomData ? roomData.streamLink : '',
        startTime: new Date(),
        endTime: new Date(),
    }

    const [modalIsOpen, setIsOpen] = useState(false)
    const openModal = () => {
        setIsOpen(true)
    }
    const afterOpenModal = () => {
        subtitle.style.color = '#f00'
    }
    const closeModal = () => setIsOpen(false)

    const [isUploading, setIsUploading] = useState(false)
    const [progress, setProgress] = useState(0)

    const [showData, setShowData] = useState(newShow)

    const setDataValue = (key, value) => setShowData({ ...showData, [key]: value })

    const id = show && show.id
    useEffect(() => {
        if (show) setShowData({ link: roomData ? roomData.streamLink : '', ...show })
    }, [roomData, show, id])

    useEffect(() => {
        if (modalIsOpen) {
            console.log(showData)
            console.log(show)
        }
    }, [modalIsOpen])

    const { duration, startTime } = showData
    useEffect(() => {
        if (duration !== undefined && startTime) {
            setDataValue('endTime', new Date(showData.startTime.getTime() + duration * 1000))
        }
    }, [duration, startTime])

    const handleGetCoordinates = async (country) => {
        let newCountry = country + ' '
        const data = await getCoordinates(newCountry)
        setShowData({ ...showData, lat: data.latitude, lon: data.longitude })
        if (data !== 'ERROR') {
        } else {
            console.log('error in the get coordinates')
        }
    }
    const handleCreateShow = async (show) => {
        let newShow = { ...show }
        console.log(newShow)
        const data = await createShow(edition, newShow)
        if (data !== 'ERROR') {
            handleGetShows(edition)
            // getEdition(edition)
            console.log('room was added')
            console.log(shows)
            //function to refresh edition data!!!!!!
        } else {
            console.log('error in the add show')
        }
    }

    const handleDeleteShow = async (e) => {
        console.log(show)
        console.log(showData)
        const data = await deleteShow(show.id)
        if (data !== 'ERROR') {
            handleGetShows(edition) //function to refresh edition data!!!!!!
            closeModal()
        } else {
            console.log('error in the remove s how')
        }
    }

    const handleEditShow = async (e) => {
        console.log(show)
        console.log(showData)
        let editedShow = { ...show, ...showData }
        console.log(editedShow)
        const data = await editShow(edition, editedShow, show.id)
        if (data !== 'ERROR') {
            handleGetShows(edition)
            closeModal()
            console.log('show was edited') //function to refresh edition data!!!!!!
        } else {
            console.log('error in the edit show')
        }
    }

    const handleSubmit = async (evt) => {
        evt.preventDefault()
        if (evt.target.value === 'delete') {
            //handleDeleteShow(edition, show.id)
        }
        if (evt.target.value === 'submit edit') {
        }
        if (evt.target.value === 'submit') {
            handleCreateShow(showData)
        }
        setShowData(newShow)
        closeModal()
    }

    //FIXME add placeholders to all the inputs
    return (
        <div>
            <div className="AddShowButton">
                {formType === 'newShow' ? (
                    <button onClick={openModal}>Add Show</button>
                ) : (
                    <button onClick={openModal}> Edit</button>
                )}
            </div>
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                {formType === 'newShow' ? (
                    <div ref={(_subtitle) => (subtitle = _subtitle)}>Add Show</div>
                ) : (
                    <div ref={(_subtitle) => (subtitle = _subtitle)}>Edit Show</div>
                )}
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', height: 540, marginTop: 16 }}>
                    <div
                        style={{
                            width: 240,
                            minWidth: 240,
                            paddingRight: 32,
                            borderRight: '1px solid white',
                            marginRight: 32,
                        }}
                    >
                        <div style={{ fontWeight: 500 }}>ARTIST INFO</div>
                        <div style={{ height: 16 }} />
                        <div className="fieldLabel">IMAGE</div>
                        {isUploading && <p>Progress: {progress}</p>}
                        {showData && showData.image && (
                            <img
                                src={showData.image}
                                style={{
                                    width: 128,
                                    height: 128,
                                    marginBottom: 16,
                                    objectFit: 'cover',
                                }}
                            />
                        )}
                        <UploadFile setFileURL={(url) => setDataValue('image', url)} />
                        <div style={{ height: 16 }} />
                        {artistFields.map((f, i) => {
                            return (
                                <>
                                    <InputComponent
                                        text={f.text}
                                        type={f.entryType}
                                        key={'field' + i}
                                        placeholder={f.placeholder}
                                        formType={formType}
                                        value={showData[f.key]}
                                        disabled={f.disabled}
                                        func={(v) => {
                                            setDataValue(f.key, v && v.target && v.target.value ? v.target.value : v)
                                        }}
                                    />
                                    <div style={{ height: 16 }} />
                                </>
                            )
                        })}

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                            <InputComponent
                                text="location"
                                value={showData.country}
                                func={(v) =>
                                    setDataValue('country', v && v.target && v.target.value ? v.target.value : v)
                                }
                                type="text"
                                isLocation={true}
                                formType={formType}
                                placeholder="city, country"
                            />
                            {showData.lat && showData.lon && (
                                <div>
                                    latitude: {showData.lat}, longitude: {showData.lon}
                                </div>
                            )}
                            <button name="coordinates" onClick={() => handleGetCoordinates(showData.country)}>
                                SEARCH
                            </button>
                        </div>
                        <div>Click search to make the stream show on the world map!</div>
                    </div>
                    <div style={{ width: 'auto' }}>
                        <div style={{ fontWeight: 700 }}>STREAM INFO</div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                            {showFields.map((f, i) => {
                                return (
                                    <>
                                        <InputComponent
                                            text={f.text}
                                            type={f.entryType}
                                            key={'field' + i}
                                            placeholder={f.placeholder}
                                            formType={formType}
                                            value={showData[f.key]}
                                            disabled={f.disabled}
                                            func={(v) => {
                                                setDataValue(
                                                    f.key,
                                                    v && v.target && v.target.value ? v.target.value : v,
                                                )
                                            }}
                                        />
                                        <div style={{ height: 16 }} />
                                    </>
                                )
                            })}
                        </div>
                        {descField.map((f, i) => {
                            return (
                                <>
                                    <InputComponent
                                        text={f.text}
                                        type={f.entryType}
                                        key={'field' + i}
                                        placeholder={f.placeholder}
                                        formType={formType}
                                        value={showData[f.key]}
                                        disabled={f.disabled}
                                        func={(v) => {
                                            setDataValue(f.key, v && v.target && v.target.value ? v.target.value : v)
                                        }}
                                    />
                                    <div style={{ height: 16 }} />
                                </>
                            )
                        })}
                        <div
                            style={{ height: 24, marginBottom: 24, marginLeft: -32, borderBottom: '1px solid white' }}
                        />
                        <div style={{ fontWeight: 700 }}>SCHEDULING INFO</div>
                        {scheduleFields.map((f, i) => {
                            return (
                                <>
                                    <InputComponent
                                        text={f.text}
                                        type={f.entryType}
                                        key={'field' + i}
                                        placeholder={f.placeholder}
                                        formType={formType}
                                        value={showData[f.key]}
                                        disabled={f.disabled}
                                        func={(v) => {
                                            setDataValue(f.key, v && v.target && v.target.value ? v.target.value : v)
                                        }}
                                    />
                                    <div style={{ height: 16 }} />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: 'auto' }}>
                        <div style={{ marginTop: 16, fontSize: 12, fontWeight: 500 }}>OPTIONAL</div>
                        {optionalFields.map((f, i) => {
                            return (
                                <InputComponent
                                    text={f.text}
                                    type={f.entryType}
                                    key={'ofield' + i}
                                    placeholder={f.placeholder}
                                    formType={formType}
                                    value={showData[f.key]}
                                    func={(v) =>
                                        setDataValue(f.key, v && v.target && v.target.value ? v.target.value : v)
                                    }
                                />
                            )
                        })}
                    </div>
                </div>
                <div style={{ marginTop: 16, display: 'flex', flexDirection: 'row' }}>
                    {formType === 'newShow' ? (
                        <input type="submit" value="submit" onClick={handleSubmit} />
                    ) : (
                        <button onClick={handleEditShow}>SUBMIT EDITS</button>
                    )}
                    {formType !== 'newShow' && <button onClick={handleDeleteShow}>DELETE</button>}
                </div>
            </Modal>
        </div>
    )
}

export default ShowForm
